import { render, staticRenderFns } from "./RateDetails.vue?vue&type=template&id=2f602f36"
import script from "./RateDetails.vue?vue&type=script&lang=js"
export * from "./RateDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports